import { Typography, Grid } from "@mui/material";

export default function VariantSelector({ groupSizes, groupColors }) {
    return (
        <Grid container spacing={1}>




            {/* Color Selector */}
            {groupColors?.length > 0 && (
                <Grid item xs={12}>
                    {/* <Typography variant="subtitle2" mb={0.5} mr={1}>Color</Typography> */}
                    <Grid container spacing={1}>
                        {groupColors&& groupColors?.filter((item) => item.name != '')?.map((color, index) => (
                            <Grid item key={index}>
                                <Grid sx={{ textAlign: "center", cursor: "pointer" }}>
                                    <Grid
                                        sx={{
                                            width: 22,
                                            height: 22,
                                            backgroundColor: color.hex,
                                            borderRadius: "6px",
                                            border: "1px solid #999",
                                            mx: "auto",
                                            "&:hover": { borderColor: "black" }
                                        }}
                                    />
                                    {/* <Typography variant="caption" display="block">
                    {color.name}
                  </Typography> */}
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            )}
            {groupSizes?.length > 0 && (
                <Grid item xs={12}>
                    {/* <Typography variant="subtitle2" mb={0.5} mr={2}>Size</Typography> */}
                    <Grid container spacing={1}>
                        {groupSizes&&  groupSizes?.filter((item) => item.name != '')?.map((size, index) => (
                            <Grid item key={index}>
                                <Grid
                                    sx={{
                                        px: 0.5,
                                        minWidth: 28,
                                        height: 22,
                                        border: "1px solid #bbb",
                                        borderRadius: "4px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        "&:hover": { borderColor: "black" }
                                    }}
                                >
                                    <Typography fontSize="0.6rem" fontWeight="bold">{size.name}</Typography>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
}
